module.exports = "/app/themes/roboyo2021/dist/img/arrow-left.svg?15c15f5ec3fcdf652c2f4fb682b6a573";